// extracted by mini-css-extract-plugin
export default {"host":"style_host__kOC0D","status":"style_status__T52Q8","type":"style_type__Qy-aW","muted":"style_muted__K+B8a","title":"style_title__YclUP"};